import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import ReactHtmlParser from 'react-html-parser'
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';
import * as RiIcons from 'react-icons/ri';
import * as FcIcons from "react-icons/fc";
const SidebarLink = styled(Link)`
  display: flex;
  color: black;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  list-style: none;
  height: 60px;
  text-decoration: none;
  //font-size: small;
  font-weight:bold !important;
  font-family:Nunito,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji !important";
  &:hover {
    background:#4e73df;
    border-left: 4px solid #632ce4;
    cursor: pointer;
    color:white;
    text-decoration:none;
  }
`;

const SidebarLabel = styled.span`
  margin-left: 16px;
`;

const SubNav=styled.div`
margin-left:10px;
margin-right:10px;

`;
const DropdownLink = styled(Link)`
  background:rgb(234, 236, 230);
  height: 40px;
  padding-left: 3rem;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #4e73df;
  //font-size: 18px;
  font-size: smaller;
  font-weight:bold;

  &:hover {
    background:#4e73df;
    cursor: pointer;
    color:white;
    text-decoration:none;
  }
`;
const DynamicFaIcon = ({ name }) => {
  const IconComponent = FaIcons[name];

  if (!IconComponent) { // Return a default one
    return <FaIcons.FaBeer />;
  }

  return <IconComponent  color='green'    />;
};

const DynamicAiIcon = ({ name }) => {
  const IconComponent = AiIcons[name];

  if (!IconComponent) { // Return a default one
    return <AiIcons.AiFillAlert />;
  }

  return <IconComponent  color='black'/>;
};

const DynamicIOIcon = ({ name }) => {
  const IconComponent = IoIcons[name];

  if (!IconComponent) { // Return a default one
    return <IoIcons.IoIosApps />;
  }

  return <IconComponent color='black' />;
};

const DynamicRiIcon = ({ name }) => {
  const IconComponent = RiIcons[name];

  if (!IconComponent) { // Return a default one
    return <RiIcons.RiAncientGateFill />;
  }

  return <IconComponent color='black' />;
};

const DynamicFcIcon = ({ name }) => {
  const IconComponent = FcIcons[name];

  if (!IconComponent) { // Return a default one
    return <RiIcons.RiAncientGateFill />;
  }

  return <IconComponent color='black' />;
};

const SubMenu = ({ item,currentLink,parentprops,menuclick }) => {
  const [subnav, setSubnav] = useState(false);

  const showSubnav = () => setSubnav(!subnav);

  const iconSwitch=(icon) =>{
//gbconsole.log("icon=",icon)
    switch(icon.split(".")[0]) {
      case 'FaIcons':
        return <DynamicFaIcon name={icon.split(".")[1]} />;
      case 'AiIcons':
          return <DynamicAiIcon name={icon.split(".")[1]} />;;  
      case 'IoIcons':
          return <DynamicIOIcon name={icon.split(".")[1]} />;; 
      case 'RiIcons':
          return <DynamicRiIcon name={icon.split(".")[1]} />;;    
      case 'FcIcons':
          return <DynamicFcIcon name={icon.split(".")[1]} />;;       
    }
  }

  return (
    <>
      <SidebarLink to="" style={(currentLink==item.path)?{ color:'white',backgroundColor: '#4e73df', fontWeight:'bold', borderLeft:'4px solid #632ce4'}:{}}  onClick={item.subNav && showSubnav}>
        <div>
        { iconSwitch(item.icon)}
          <SidebarLabel  onClick={()=>{parentprops(item.path);menuclick()}}>{item.title}</SidebarLabel>
        </div>
        <div className='droplink'>
          {item.subNav && subnav
            ? item.iconOpened
            : item.subNav
            ? item.iconClosed
            : null}
        </div>
      </SidebarLink>
      <SubNav className={item.subNav && subnav?'bg-white py-2 collapse-inner rounded':''}>
      {subnav &&
        item.subNav.map((item, index) => {
          return (
            
            <DropdownLink  to="" style={(currentLink==item.path)?{ backgroundColor: '#798e8e', borderLeft:'4px solid #632ce4'}:{}}>
            { iconSwitch(item.icon)}
              
              <SidebarLabel onClick={()=>{parentprops(item.path);menuclick()}}>{item.title}</SidebarLabel>
            </DropdownLink>
            
          );
        })}
        </SubNav>
        <hr/>
    </>
  );
};

export default SubMenu;
